export default "__VITE_ASSET__DFGtDaun__"